export default Object.freeze({
  FORM: 'form',
  REGISTRATION: 'registration',
})
